import { Cap } from "./cap";
import { Comune,  } from "./comune";
import { Trascodifica } from "./trascodifica";
import { Provincia } from "./provincia";
import { AnagraficaAutocomplete } from "./anagrafica-autocomplete";

export class ImmobileSearch {
    id: number;

    proprietari: Array<AnagraficaAutocomplete>;

    riferimento: string;

    numeroPagina: number;
    numeroElementi: number;
    
    idTipologiaImmobile: Array<number>;
    tipologiaImmobile: Array<Trascodifica>;
    provincie: Array<Provincia>;
    idsComune: Array<number>;
    comuni: Array<Comune>;
    idCap: Array<number>;
    cap: Array<Cap>;
    idTipologiaAnnuncio: number;
    tipologiaAnnuncio: Array<Trascodifica>;
    prezzoMin: number;
    prezzoMax: number;
    superficieMin: number;
    superficieMax: number;
    numeroLocaliMin: number;
    numeroLocaliMax: number;


    numeroBagniMin: number;
    numeroBagniMax: number;

    dataDisponibilita: Date;

    piano: string;

    numeroPianiMin: number;
    numeroPianiMax: number;

    autorizzazioneBlocco;

    indirizzo: string;

    // Dato catasto
    particella: string;

    foglio: string;

    subalterno: string;

    zonaCensuaria: string;

    classeCatasto: string;

    rendita: string;

    idCategoria: Array<number>;
    categoria: Array<Trascodifica>;

    idInformazioniCatastali: number;

    idCategoriaCatastale: Array<number>;
    categoriaCatastale: Array<Trascodifica>;

    idConsistenzaCatasto: number;

    idDisponibilita: Array<number>;
    disponibilita: Array<Trascodifica>;

    idTipologiaProprieta: Array<number>;
    tipologiaProprieta: Array<Trascodifica>;

    idProfilo: number;

    idStatoImmobile: Array<number>;
    statoImmobile: Array<Trascodifica>;

    affittoConRiscatto: boolean;

    ascensore: boolean;

    idCucina: Array<number>;
    cucina: Array<Trascodifica>;

    idBox: Array<number>;
    box: Array<Trascodifica>;

    idInfissi: Array<number>;
    infissi: Array<Trascodifica>;

    portaBlindata: boolean;

    impiantoAllarme: boolean;

    cancelloElettrico: boolean;

    videocitofono: boolean;

    portineria: boolean;

    giardino: boolean;

    arredamento: boolean;

    balcone: boolean;

    terrazzo: boolean;

    speseCondominialiAnnueMin: number;
    speseCondominialiAnnueMax: number;
    speseCondominialiAnnueAssenti: boolean;

    speseRiscaldamentoAnnueMin: number;
    speseRiscaldamentoAnnueMax: number;
    speseRiscaldamentoAnnueAssenti: boolean;

    descrizione: string;

	/*
	 * Efficientza Energetica
	 */
    annoCostruzioneMin: number;
    annoCostruzioneMax: number;
    annoCostruzioneAntecedente: boolean;
    climatizzatore: boolean;
    consumoMin: number;
    consumoMax: number;
    inAttessaCertificazione: boolean;
    esenteCertificazione: boolean;
    idStato: number;
    idTipologiaRiscaldamento: Array<number>;
    tipologiaRiscaldamento: Array<Trascodifica>;
    idClasseEnergetica: Array<number>;
    classeEnergetica: Array<Trascodifica>;

    constructor(){
        this.provincie = new Array<Provincia>();
        this.comuni = new Array<Comune>();
        this.cap = new Array<Cap>();
        this.climatizzatore = false;
        this.affittoConRiscatto = false;
        this.ascensore = false;
        this.portaBlindata = false;
        this.impiantoAllarme = false;
        this.cancelloElettrico = false;
        this.videocitofono = false;
        this.portineria = false;
        this.giardino = false;
        this.arredamento = false;
        this.balcone = false;
        this.terrazzo = false;
        this.tipologiaAnnuncio = new Array<Trascodifica>();
    }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/immobile-search.ts